/**
 * "Traces in" on an agent platform's connection: the trace connection its runs
 * write their traces to (Orchestrator: its Langfuse project). Each run's
 * "Open trace" link is asked of it; with none, runs have no link.
 */

import { Field } from "@/components/ui/field";
import { Select } from "@/components/ui/select";
import type { Connector } from "@/features/connectors/types";
import { useConnections } from "./hooks";

export function TracesInField({
  connectors,
  value,
  onChange,
}: {
  connectors: Connector[];
  /** The trace connection's id; "" for none. */
  value: string;
  onChange: (value: string) => void;
}) {
  const connections = useConnections();
  const traceTypes = new Map(connectors.filter((c) => c.kind === "traces").map((c) => [c.type, c.label]));
  const options = (connections.data ?? [])
    .filter((c) => traceTypes.has(c.connector_type))
    .map((c) => ({ value: c.id, label: c.name, hint: traceTypes.get(c.connector_type) }));
  return (
    <Field
      label="Traces in"
      htmlFor="traces-in"
      optional
      hint="Where this platform's runs write their traces, so each run links to its own."
    >
      <Select
        id="traces-in"
        value={value}
        onChange={onChange}
        options={[{ value: "", label: "None (runs have no trace link)" }, ...options]}
      />
    </Field>
  );
}
